import React, {useState} from "react";
import { Collapse } from "antd";
import { FormattedMessage } from "react-intl";
import "../style.css";
import { useIntl } from "react-intl";

const { Panel } = Collapse;

const CommunityTemplatesFilters = ({
  changeCategories,
  // changeRatings,
  changeAuthors,
  // onDateSorting,
  // dateSortingOrder,
  templatesCategories,
  templatesAuthors
  // templatesRatings
}) => {
  const intl = useIntl();
  const [selectedCategory, setSelectedCategory] = useState("Tutte");
  const [selectedAuthor, setSelectedAuthor] = useState(intl.formatMessage({ id: "all"}));

  const onCategoriesChange = (cat) => {
    setSelectedCategory(cat);
    changeCategories(cat);
  };

  const onAuthorsChange = (author) => {
    setSelectedAuthor(author);
    changeAuthors(author);
  };

  const categories = templatesCategories.map((cat, index) => {
    return <h4 className="askEdit-filters-options"
				   key={index}
				   onClick={() => onCategoriesChange(cat)}
				   style={{color: selectedCategory === cat && "rgb(0, 144, 209)"}}
    >
      {<FormattedMessage id={cat !== "Tutte" ? `ask.categories.${cat}` : "ask.categories.all" }/>}
    </h4>;
  });
  const authors = templatesAuthors.map((author, index) => {
    return <h4 className="askEdit-filters-options"
				   key={index}
				   onClick={() => onAuthorsChange(author)}
				   style={{color: selectedAuthor === author && "rgb(0, 144, 209)"}}
    >
      {author}
    </h4>;
  });

  /* to decomment once we will have the date sorter /*

	// const sortersTemplateData = [
	// 	{
	// 		title:<FormattedMessage id="ask.pages.edit.communityTemplates.sorterTitleDate" />,
	// 		onClick: onDateSorting,
	// 		icon:["fas", `${dateSortingOrder === "desc" ? "sort-amount-down-alt" : "sort-amount-up-alt"}`]
	// 	},
	// 	/*{
	// 		title:<FormattedMessage id="ask.pages.edit.communityTemplates.sorterTitlePrice" />,
	// 		onClick: "",
	// 		icon: ["fas", "sort-amount-down-alt"]
	// 	}*/
  // ];
  //   const sorters = sortersTemplateData.map((s, index) => {
  // 		return (
  // 			<div className="communityTemplatesSortersContainer" key={index}>
  // 				<div className="communityTemplatesSorterButton">
  // 					<h5 className="communityTemplatesSorterTitle"> {s.title}</h5>
  // 				</div>
  // 				<FontAwesomeIcon
  // 					icon={s.icon}
  // 					className="communityTemplatesSorterIcon"
  // 					onClick={s.onClick}
  //         />
  // 			</div>
  // 		)
  // 	})

  const filtersPanelsData = [
    {
      header: <FormattedMessage id="ask.pages.edit.communityTemplates.filterTitleCategory" />,
      content: categories

    },
    {
      header: <FormattedMessage id="ask.pages.edit.communityTemplates.filterTitleAuthors" />,
      content: authors
    }
  ];

  const filtersPanels = filtersPanelsData.map((panel, index) => {
    return  (
      <Panel
			  header={panel.header}
			  className="header-collapse-custom-panel-custom-panel"
			  key={index}
      >
			  {panel.content}
      </Panel>
		  );
  });
  return (
    <>
      {/* {sorters} */}
      <Collapse
        bordered={false}
        className="askEdit-collapse-filters"
      >
        {filtersPanels}
      </Collapse>
    </>
  );
};

export default CommunityTemplatesFilters;